import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { toast } from "sonner";

const STATUSES = [
  { id: "new", label: "New", dot: "bg-red-500" },
  { id: "in_progress", label: "In Progress", dot: "bg-yellow-400" },
  { id: "resolved", label: "Resolved", dot: "bg-green-500" },
];

export default function AdminSupport() {
  const [requests, setRequests] = useState([]);

  const load = () => {
    api.get("/admin/support-requests").then((r) => setRequests(r.data)).catch(() => toast.error("Could not load support requests"));
  };

  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/admin/support-requests/${id}`, { status });
      toast.success("Status updated");
      load();
    } catch {
      toast.error("Update failed");
    }
  };

  return (
    <AdminLayout title="Live Support Requests">
      <div className="rounded-3xl border border-white/10 bg-white/[0.02] overflow-x-auto" data-testid="support-requests-table">
        <table className="w-full text-sm min-w-[820px]">
          <thead>
            <tr className="text-left text-xs tracking-[0.15em] uppercase text-slate-500 border-b border-white/10">
              <th className="px-6 py-4">Student</th>
              <th className="px-6 py-4">Contact</th>
              <th className="px-6 py-4">Question</th>
              <th className="px-6 py-4">Date & Time</th>
              <th className="px-6 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => {
              const st = STATUSES.find((s) => s.id === r.status) || STATUSES[0];
              return (
                <tr key={r.request_id} data-testid={`support-request-row-${r.request_id}`} className="border-b border-white/5 align-top">
                  <td className="px-6 py-4 text-white font-medium">{r.name || "-"}</td>
                  <td className="px-6 py-4 text-slate-400">
                    <div>{r.email}</div>
                    {r.phone && <div className="text-xs text-slate-600">{r.phone}</div>}
                  </td>
                  <td className="px-6 py-4 text-slate-300 max-w-xs"><p className="line-clamp-3 leading-relaxed">{r.question}</p></td>
                  <td className="px-6 py-4 text-slate-500 whitespace-nowrap">{(r.created_at || "").replace("T", " ").slice(0, 16)}</td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <span className="inline-flex items-center gap-2 text-slate-200 whitespace-nowrap" data-testid={`support-status-${r.request_id}`}>
                        <span className={`w-2 h-2 rounded-full ${st.dot}`} /> {st.label}
                      </span>
                      <select
                        data-testid={`support-status-select-${r.request_id}`}
                        value={r.status}
                        onChange={(e) => updateStatus(r.request_id, e.target.value)}
                        className="bg-white/5 border border-white/10 rounded-full px-3 py-1.5 text-xs text-white outline-none [&>option]:bg-[#0A1633]"
                      >
                        {STATUSES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                      </select>
                    </div>
                  </td>
                </tr>
              );
            })}
            {!requests.length && (
              <tr><td colSpan={5} className="px-6 py-12 text-center text-slate-500">No support requests yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
